<template>
  <pc-verification-modal
    v-if="isReady"
    :key="type"
    :type="type"
    :is-resident="userInfo.is_resident"
    :error="$t(verificationModalError)"
    :show-resend="showResendButton"
    :block-time="blockTime"
    :live-time="liveTime"
    :show-contacts="otpData.showContacts"
    :tries-left="triesLeft"
    :hide-countdown="otpData.hideCountdown"
    :show-close="otpData.showClose"
    :show-loader="showLoader"
    email-to="support"
    @resend="resendCode()"
    @close="closeOtp"
    @confirm="verify"
  >
    <template #title>
      <span v-html="$t(`verification-modal.code-was-sent-to`, {'contact': userInfo[type] || contactData})" />
    </template>
  </pc-verification-modal>
</template>

<script>
import PcVerificationModal from '@/components/modals/PcVerificationModal'
import {mapGetters} from 'vuex'
import {differenceInSeconds, parseISO, getUnixTime} from 'date-fns'
import {getBackendErrorMessage} from '@/errorHandler'

export default {
  name: 'OtpVerification',
  components: {PcVerificationModal},
  data() {
    return {
      isReady: false,
      verificationModalError:'',
      showResendButton: false,
      blockTime: 0,
      triesLeft: 3,
      liveTime: null,
      otp_id: null,
      contactData: '',
      email: '',
      showLoader: false
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'otpData']),
    type(){
      return (this.userInfo.confirmation_type === 'sms' && this.userInfo.can_send_sms) ||
      this.otpData.phoneOnly? 'phone' : 'email'
    }
  },
  async mounted() {
    const res = await this.getCode()
    if(res) {
      this.isReady = true
    } else {
      this.closeOtp()
    }
  },
  methods: {
    async verify(code){
      try{
        const formData = {code}
        if(this.otp_id){
          formData.otp_id = this.otp_id
        }
        this.showLoader = true
        await this.otpData.confirmCodeApi(formData, this.otpData.confirmCodeApiData)
        await this.$store.dispatch('confirmOtp', this.otpData.id)
      }catch(err){
        if(err.response?.data?._error_code) {
          this.$toast.error(this.$t('notifications.something-went-wrong'))
        } else {
          const error = err.response?.data
          this.verificationModalError = error?.message
        }
        console.log(err)
      }
      this.showLoader = false
      --this.triesLeft
    },
    closeOtp(){
      this.$store.dispatch('hideOtp')
    },
    async getCode() {
      this.blockTime = 0
      this.liveTime = 0
      this.triesLeft = 0
      this.verificationModalError = ''
      try {
        const {data} = await this.otpData.getCodeApi(this.otpData.getCodeApiData)
        this.otp_id = data.otp_id || null
        this.liveTime = data.seconds_left
        this.triesLeft = 3 - data.tries
        this.contactData = data.phone
        if(this.otpData.phoneOnly && Object.hasOwn(data, 'sms_otp_is_available') && !data.sms_otp_is_available){
          await this.$store.dispatch('confirmOtp',this.otpData.id)
        }
        return true
      }catch(err){
        const error = err.response.data
        if(error._error_code) {
          setTimeout(()=> { this.$toast.error(this.$i18n.t(getBackendErrorMessage(err)))},0)

          return false
        }
        if(error.email){
            this.$store.dispatch('setOtpBackendError', error)
            this.$store.dispatch('hideOtp')
        }else {
          this.handleBlockTime(error.block_until, error.server_time)
          this.liveTime = 0
          this.triesLeft = 0
          this.verificationModalError = error.message
        }
        console.log(err)
      }
    },

    handleBlockTime(blockUntil, serverTime) {
      let seconds = Math.round(blockUntil - serverTime)
      this.blockTime = seconds
      const minutes = (Math.floor(seconds / 60)).toString()
      seconds = (seconds % 60).toString()
      this.$toast.error(this.$t('notifications.next-try-will-be-available', { minutes: minutes.padStart(2, '0'), seconds: seconds.padStart(2, '0')}))
    },

    resendCode() {
      this.triesLeft = 3
      this.getCode()
    }

  }
}
</script>

<style scoped>

</style>
